import moment from "moment";
import DateRangePickerComponent from "../../../components/common/CustomDateRangePicker";
import { Box, Button, CircularProgress, FormControl, Grid, InputAdornment, MenuItem, Pagination, Paper, Select, styled, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import { useEffect, useState } from "react";
import ReportsTableHeader from "../report-table-header.component";
import { format } from "date-fns";
import GeolocationVerificationSkeleton from "../skeleton/geolocation-verification-skeleton";
import ReportService from "../../../services/api/reports";
import ExportAlertNotificationDialog from "../../alert/export-alert-notification-dialog.component";
import CachedIcon from "@mui/icons-material/Cached";
import {useSnackbar} from "notistack";

const SmallSelect = styled(Select)(({ theme, fontColor }) => ({
    minWidth: 120,  // Adjust the width as needed
    height: 33,     // Adjust the height as needed
    fontSize: '0.875rem',  // Adjust the font size as needed
    '.MuiSvgIcon-root': {
        color: fontColor, // Change to your desired color
    },
    color: fontColor,
    backgroundColor: '#fff',
    border: "1px solid #7A78F7",
    "& .MuiInputBase-root": { height: 33, border: "1px solid #7A78F7", color: "#3333CFCE", backgroundColor: '#fff', width: 250, borderRadius: "5px" },
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "& .MuiSelect-select": {
        fontSize: 12,
        fontStyle: 'italic'
    },
    "& .MuiMenuItem-root": {
        fontSize: 12,
    },
    "& .Mui-selected": {
        fontSize: 12,
        fontStyle: 'italic'
    },
}));

const GeolocationVerificationFilterComponent = (props) => {

    const {headers, listProducts, isLoadingVerification, getGeolocationVerification, 
        geolocationVerification, page, setPage, listOfCountry, 
        getRegion, regionList, getProvince, listOfProvince, getCityMunicipality, listOfCityMuni} = props;

    const {enqueueSnackbar} = useSnackbar();

    const [region_name, setRegion] = useState(null);
    const [country_name, setCountry] = useState(null);
    const [province_name, setProvince] = useState(null);
    const [cityMuni, setCityMuni] = useState(null);
    const [product_name, setProductName] = useState("");
    const [open, setOpen] = useState(false)
    const [isLoadingAlertNotification, setIsLoadingAlertNotification] = useState(false)
    const [reportID, setReportID] = useState(null)

    const [startDate, setStartDate] = useState(moment().subtract(6, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));

    
    useEffect(() => {
        const start_date = startDate;
        const end_date = endDate;
        const product_code = product_name || '';
        const country = country_name || '';
        const region = region_name || '';
        const province = province_name || '';
        const city_municipality = cityMuni || '';
    
        let report_type;
    
        if (!product_code && !country && !region && !province && !city_municipality) {
            report_type = 1; // Default to 1 (startDate + endDate)
        } else if (product_code) {
            if (country) {
                if (region) {
                    if (province) {
                        report_type = city_municipality ? 10 : 9; // Based on city_municipality presence
                    } else {
                        report_type = 8; // startDate + endDate + country + region + product
                    }
                } else {
                    report_type = 7; // startDate + endDate + country + product
                }
            } else {
                report_type = 2; // startDate + endDate + product
            }
        } else if (country) {
            if (region) {
                if (province) {
                    report_type = city_municipality ? 6 : 5; // Based on city_municipality presence
                } else {
                    report_type = 4; // startDate + endDate + country + region
                }
            } else {
                report_type = 3; // startDate + endDate + country
            }
        }
    
        const payload = {
            start_date: start_date,
            end_date: end_date,
            product_code: product_code ? [product_code] : [],
            country: country,
            region: region,
            province: province,
            city_municipality: city_municipality,
            report_type: report_type
        };
    
        getGeolocationVerification(payload);
    }, [startDate, endDate, product_name, country_name, region_name, province_name, cityMuni]);

    useEffect(() => {
        if (country_name) {
            getRegion(country_name);
    
            if (region_name) {
                getProvince(country_name, region_name);
    
                if (province_name) {
                    getCityMunicipality(country_name, region_name, province_name);
                }
            }
        }
    }, [country_name, region_name, province_name, page])

  
    const handleDateRangeChange = (newStartDate, newEndDate) => {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    }

    const handleClose = () =>{
        setOpen(false)
    }

    const handleExport = () => {

        const start_date = startDate;
        const end_date = endDate;
        const product_code = product_name || '';
        const country = country_name || '';
        const region = region_name || '';
        const province = province_name || '';
        const city_municipality = cityMuni || '';
    
        let report_type;
    
        if (!product_code && !country && !region && !province && !city_municipality) {
            report_type = 1; // Default to 1 (startDate + endDate)
        } else if (product_code) {
            if (country) {
                if (region) {
                    if (province) {
                        report_type = city_municipality ? 10 : 9; // Based on city_municipality presence
                    } else {
                        report_type = 8; // startDate + endDate + country + region + product
                    }
                } else {
                    report_type = 7; // startDate + endDate + country + product
                }
            } else {
                report_type = 2; // startDate + endDate + product
            }
        } else if (country) {
            if (region) {
                if (province) {
                    report_type = city_municipality ? 6 : 5; // Based on city_municipality presence
                } else {
                    report_type = 4; // startDate + endDate + country + region
                }
            } else {
                report_type = 3; // startDate + endDate + country
            }
        }
    
        const payload = {
            start_date: start_date,
            end_date: end_date,
            product_code: product_code ? [product_code] : [],
            country: country,
            region: region,
            province: province,
            city_municipality: city_municipality,
            report_type: report_type
        };
        
        if (geolocationVerification?.length > 0) {
            setIsLoadingAlertNotification(true);

            ReportService.exportGeolocationVerification(payload).then((res)=>{
                console.log('get export alert and notification res here', res)
                setIsLoadingAlertNotification(false)
                setReportID(res?.data?.data?.report_id)
                setOpen(true)
            }).catch(() => {
                setIsLoadingAlertNotification(false);
            })

        } else {
            enqueueSnackbar("No data to export", { 
                variant: "error",
                autoHideDuration: 3000
            });
        }
        
    }

    const handleChangeProductName = (event) => {
        setProductName(event.target.value);

    };

    const handleSelectCountry = (event) => {
        setCountry(event.target.value)
    }

    const handleSelectRegion = (event) => {
        setRegion(event.target.value)
    }

    const handleSelectProvince = (event) => {
        setProvince(event.target.value)
    }

    const handleSelectCityMuni = (event) => {
        setCityMuni(event.target.value)
    }

    const itemsPerPage = 100;

    // Calculate the total number of pages
    const totalPages = Math.ceil((geolocationVerification?.length || 0) / itemsPerPage);

    // Get the current items to display
    const currentItems = (geolocationVerification || []).slice((page - 1) * itemsPerPage, page * itemsPerPage);

    // Handler to change page
    const handlePageChange = (event, value) => {
        setPage(value);
    }

    const handleClearFilters = (e) => {
        setProductName("");
        setRegion(null);
        setCountry(null);
        setProvince(null);
        setCityMuni(null);
        setStartDate(moment().subtract(6, "days").format("YYYY-MM-DD"));
        setEndDate(moment().format("YYYY-MM-DD"));
    }


    return (
        <Box>
            <Grid container sx={{ justifyContent: "flex-end", alignItems: "center", mt: 3}}>
                <Grid item xs={3}>
                    <Button variant="contained" sx={{height: "33px", textTransform: "none", backgroundColor: "#5959D8", color: "#fff", "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                        startIcon={<CachedIcon />} onClick={(e) => handleClearFilters(e)}
                    >
                        Clear Filters
                    </Button>
                </Grid>

                <Grid item xs={9} sx={{ display: 'flex', justifyContent: "flex-end" }}>
                    <FormControl sx={{ width: 250 }}>
                        <SmallSelect
                            value={product_name}
                            onChange={handleChangeProductName}
                            displayEmpty
                            fontColor={'#5d5ed8'}
                            startAdornment={
                                <InputAdornment position="start">
                                    <p style={{ fontSize: 12, margin: 0, color: "#3333CFCE", fontWeight: 'bold' }}>
                                        Product Name:
                                    </p>
                                </InputAdornment>
                            }
                        >
                            <MenuItem value="" disabled sx={{ fontSize: 12 }}>
                                <em>Select Product</em>
                            </MenuItem>
                           
                            {listProducts?.map((list, index)=>{
                                return(
                                    <MenuItem value={list?.product_code} sx={{ fontSize: 12 }}>
                                        {list?.product_name}
                                    </MenuItem>
                                )
                            })}
                        </SmallSelect>
                    </FormControl>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <FormControl sx={{ width: 250 }}>
                        <SmallSelect
                            value={country_name}
                            onChange={handleSelectCountry}
                            displayEmpty
                            fontColor={'#5d5ed8'}
                            startAdornment={
                                <InputAdornment position="start">
                                    <p style={{ fontSize: 12, margin: 0, color: "#3333CFCE", fontWeight: 'bold' }}>
                                        Country:
                                    </p>
                                </InputAdornment>
                            }
                        >
                            <MenuItem value="" disabled sx={{ fontSize: 12 }}>
                                <em>Select Country</em>
                            </MenuItem>
                           
                            {listOfCountry?.map((list, index)=>{
                                return(
                                    <MenuItem value={list?.country} sx={{ fontSize: 12 }}>
                                        {list?.country}
                                    </MenuItem>
                                )
                            })}
                        </SmallSelect>
                    </FormControl>

                    &nbsp;&nbsp;&nbsp;&nbsp;
                    
                    <DateRangePickerComponent
                        initialStartDate={startDate}
                        initialEndDate={endDate}
                        ranges={{
                            "Last 7 Days": [moment().subtract(6, 'days'), moment()],
                            "This Month": [moment().startOf('month'), moment().endOf('month')],
                            "Last Month": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                            "Last 90 Days": [moment().subtract(89, 'days'), moment()],
                        }}
                        onDateRangeChange={handleDateRangeChange}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button
                        onClick={handleExport}
                        variant="contained"
                        startIcon= {isLoadingAlertNotification ? <CircularProgress sx={{color:'white'}} size={11} /> : <DownloadIcon />}
                        sx={{ fontSize: 12, background: '#3333CFCE', color: '#fff', textTransform: 'none', "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                    >
                        {isLoadingAlertNotification ? "Exporting" : "Export"}
                    </Button>
                </Grid>

                {country_name &&
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: "flex-end", mt: 2 }}>
                        <FormControl sx={{ width: 250 }}>
                            <SmallSelect
                                value={region_name}
                                onChange={handleSelectRegion}
                                displayEmpty
                                fontColor={'#5d5ed8'}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <p style={{ fontSize: 12, margin: 0, color: "#3333CFCE", fontWeight: 'bold' }}>
                                            Region:
                                        </p>
                                    </InputAdornment>
                                }
                            >
                                <MenuItem value="" disabled sx={{ fontSize: 12 }}>
                                    <em>Select Region</em>
                                </MenuItem>
                            
                                {regionList?.map((list, index)=>{
                                    return(
                                        <MenuItem value={list?.region} sx={{ fontSize: 12 }}>
                                            {list?.region}
                                        </MenuItem>
                                    )
                                })}
                            </SmallSelect>
                        </FormControl>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <FormControl sx={{ width: 250 }}>
                            <SmallSelect
                                value={province_name}
                                onChange={handleSelectProvince}
                                displayEmpty
                                fontColor={'#5d5ed8'}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <p style={{ fontSize: 12, margin: 0, color: "#3333CFCE", fontWeight: 'bold' }}>
                                            Province:
                                        </p>
                                    </InputAdornment>
                                }
                            >
                                <MenuItem value="" disabled sx={{ fontSize: 12 }}>
                                    <em>Select Province</em>
                                </MenuItem>
                            
                                {listOfProvince?.map((list, index)=>{
                                    return(
                                        <MenuItem value={list?.province} sx={{ fontSize: 12 }}>
                                            {list?.province}
                                        </MenuItem>
                                    )
                                })}
                            </SmallSelect>
                        </FormControl>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <FormControl sx={{ width: 250 }}>
                            <SmallSelect
                                value={cityMuni}
                                onChange={handleSelectCityMuni}
                                displayEmpty
                                fontColor={'#5d5ed8'}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <p style={{ fontSize: 12, margin: 0, color: "#3333CFCE", fontWeight: 'bold' }}>
                                            City/Municipality:
                                        </p>
                                    </InputAdornment>
                                }
                            >
                                <MenuItem value="" disabled sx={{ fontSize: 12 }}>
                                    <em>Select City/Municipality</em>
                                </MenuItem>
                            
                                {listOfCityMuni?.map((list, index)=>{
                                    return(
                                        <MenuItem value={list?.city} sx={{ fontSize: 12 }}>
                                            {list?.city}
                                        </MenuItem>
                                    )
                                })}
                            </SmallSelect>
                        </FormControl>
                    </Grid>
                }
            </Grid>
            <Grid item xs={12}>
                <Paper sx={{ width: '100%', overflow: 'hidden', mt: 3,  }}>
                    <TableContainer sx={{ border: "1px solid #3333cf54", borderRadius: 2, width: "100%", maxHeight: 600}}>
                        <Table stickyHeader sx={{ minWidth: 650 }}>
                            <ReportsTableHeader headers={headers} />
                            {isLoadingVerification ? 
                                <TableBody>
                                    <GeolocationVerificationSkeleton/>
                                </TableBody>
                            :
                            <TableBody>
                                    {currentItems?.map((label, index) => (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell key={index} component="th" scope="row">
                                                {label.verification_id}
                                            </TableCell>
                                            <TableCell key={index} component="th" scope="row">
                                                {label?.productInfo[0]?.product_name}
                                            </TableCell>
                                            
                                            <TableCell key={index} component="th" scope="row">
                                                {label?.street ? label.street : ""} {label?.barangay ? label.barangay : ""}, {label?.city ? label.city : ""}, {label?.province ? label.province : ""} {label?.zip_code ? label.zip_code : ""}, {label?.country ? label.country : ""}
                                            </TableCell>
                                            <TableCell key={index} component="th" scope="row">
                                                {label?.timestamp ? format(new Date(label?.timestamp), "PP"): 'NA'}
                                            </TableCell>
                                            <TableCell key={index} component="th" scope="row" sx={{color: label.status === "Successful" ? "green" : 'red'}}>
                                                {label.status}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            }
                        </Table>
                        
                        {/* ERROR MESSAGE */}
                        {!isLoadingVerification && geolocationVerification?.length === 0 && <Box sx={{textAlign:'center', m: 2}}> <Typography sx={{color:'gray', fontSize: 12}}>No data available.</Typography></Box>}
                    </TableContainer>
                    {!isLoadingVerification ?
                        <Box display="flex" justifyContent="center" mt={2} mb={2}>
                            <Pagination
                                count={totalPages}
                                page={page}
                                onChange={handlePageChange}
                                sx={{
                                    "& .MuiPaginationItem-root.Mui-selected": {
                                        color: "#fff",
                                        backgroundColor: "#5959D8"
                                    }
                                }} 
                            />
                        </Box>
                    : null}
                </Paper>
            </Grid>
            {/* DIALOG */}
            <ExportAlertNotificationDialog open={open} reportID={reportID} handleClose={handleClose}/>
        </Box>
    )

}

export default GeolocationVerificationFilterComponent